/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import * as Styles from '../../../Maintain/client/Components/StyleConstant';
import ActionButtonRenderer from './ActionButtonRenderer';
import CalculatedInterestQuarterDetailsTable from './CalculatedInterestQuarterDetailsTable';
import { setDrugInterestResposne } from '../store/actions';
import {
  amountComparator,
  cellRenderer,
  comparatorQtr,
} from '../../../../SharedModules/utilities/utilities';

const CalculatedInterestDetailsTable = ({
  fullScreen,
  setFullScreen,
  reportData,
  ndcpagination,
}) => {
  const MAN_HEAD = [
    {
      headerName: 'Action',
      field: '',
      editable: false,
      minWidth: 160,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: false,
      filter: false,
      cellStyle: {
        'border-right-color': Styles.BorderColor,
      },
      cellRenderer: ActionButtonRenderer,
      cellRendererParams: {
        callBackMenuItem: gridMenuItemCallBack,
        selectedRow: selectedRow,
      },
      pdfExportOptions: {
        skipColumn: true,
      },
    },
    {
      headerName: 'Quarter',
      field: 'qtr',
      minWidth: 160,
      maxLength: Styles.Length_255,
      comparator: comparatorQtr,
      sortable: true,
      editable: false,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Principal Due',
      field: 'principalDue',
      minWidth: 250,
      editable: false,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: true,
      cellRenderer: cellRenderer,
      comparator: amountComparator,
      printPrefixValue: '$',
      isTextColorRed: true,
      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
      exportOption: {
        printWithCurrency: '$',
      },
    },
    {
      headerName: 'Previous Interest',
      field: 'preIntrest',
      editable: false,
      minWidth: 280,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,

      sortable: true,
      cellRenderer: cellRenderer,
      comparator: amountComparator,
      printPrefixValue: '$',
      isTextColorRed: true,
      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
      exportOption: {
        printWithCurrency: '$',
      },
    },
    {
      headerName: 'New Interest',
      field: 'newInt',
      minWidth: 160,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      editable: false,
      sortable: true,

      cellRenderer: cellRenderer,
      comparator: amountComparator,
      printPrefixValue: '$',
      isTextColorRed: true,
      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
      exportOption: {
        printWithCurrency: '$',
      },
    },
    {
      headerName: 'Total Interest',
      field: 'totalInt',
      minWidth: 280,
      editable: false,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: true,
      cellRenderer: cellRenderer,
      comparator: amountComparator,
      printPrefixValue: '$',
      isTextColorRed: true,
      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
      exportOption: {
        printWithCurrency: '$',
      },
    },
    {
      headerName: 'Total Amount Due',
      field: 'totalDue',
      minWidth: 320,
      editable: false,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: true,
      cellRenderer: cellRenderer,
      comparator: amountComparator,
      printPrefixValue: '$',
      isTextColorRed: true,
      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
      exportOption: {
        printWithCurrency: '$',
      },
    },
  ];
  const dispatch = useDispatch();
  const [tableCount, setTableCount] = useState(0);
  const [gridApi, setGridApi] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [displayChildGrid, setDisplayChildGrid] = useState(false);
  const [gridDisplayMatrix, setGridDisplayMatrix] = useState({
    LTGridDisplay: true,
    grid1Display: true,
    grid2Display: true,
  });
  useEffect(() => {
    if (fullScreen == false) {
      setGridDisplayMatrix({
        LTGridDisplay: true,
        grid1Display: true,
        grid2Display: true,
      });
    }
  }, [fullScreen]);
  const handleFullScreenGird1 = () => {
    setGridDisplayMatrix({
      LTGridDisplay: false,
      grid1Display: true,
      grid2Display: false,
    });
    setFullScreen(!fullScreen);
  };
  const handleFullScreenGird2 = () => {
    setGridDisplayMatrix({
      LTGridDisplay: false,
      grid1Display: false,
      grid2Display: true,
    });
    setFullScreen(!fullScreen);
  };
  const gridData = useSelector(
    (state) =>
      state?.sharedState?.CalculatedInterestReducer.drugInterestResponse
  );

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);
  useEffect(() => {
    resetFilters();
    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi]);
  useEffect(() => {
    dispatch(setDrugInterestResposne([]));
    setDisplayChildGrid(false);
  }, []);
  useEffect(() => {
    if (gridData?.length > 0) {
      setDisplayChildGrid(true);
    } else {
      setDisplayChildGrid(false);
    }
  }, [gridData, gridApi]);
  React.useEffect(() => {
    setDisplayChildGrid(false);
  }, [ndcpagination]);

  React.useEffect(()=>{
    const elem = document.getElementById('secondgrid');
    if (elem) {
        elem.scrollIntoView();
    }
  }, [displayChildGrid, gridDisplayMatrix.grid2Display]);

  const gridMenuItemCallBack = () => {};
  const resetFilters = () => {
    gridApi && gridApi.setFilterModel(null);
  };
  const [applyFilter, setApplyFilter] = useState(false);
  const onSelectionChanged = useCallback(() => {
    setSelectedRow(gridApi.getSelectedRows());
    // window.scrollTo(0, document.body.scrollHeight);
  }, [gridApi]);
  const handleFullScreenView = () => {
    setFullScreen(!fullScreen);
  };
  return (
    <>
      {gridDisplayMatrix.grid1Display && (
        <div
          className="tabs-container tBillPanel custom-check"
          style={{ minHeight: 'auto' }}
        >
          <>
            <div className="table-container p-0 eightRecords col-12 no-border">
              <TableGridWithFeatures
                data-testid="CAL-MFG-table"
                fullScreenView={fullScreen}
                handleFullScreenViewClick={handleFullScreenGird1}
                gridHeight={fullScreen ? '100vh' : 350}
                onGridReady={onGridReady}
                rowData={reportData}
                columnDefs={MAN_HEAD}
                exportFile
                sideBar={false}
                singleClickEdit
                suppressCellFocus
                onFilterChanged={(e) => {
                  setTableCount(e.api.getDisplayedRowCount());
                  if (
                    (
                      e.api.getFilterModel() &&
                      Object.keys(e.api.getFilterModel())
                    ).length > 0
                  ) {
                    setApplyFilter(true);
                  } else {
                    setApplyFilter(false);
                  }
                }}
                fileName="Calc Interest Details - NDC"
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </>
        </div>
      )}

      <div id="secondgrid">
        {displayChildGrid && (
          <>
            {gridDisplayMatrix.grid2Display && (
              <CalculatedInterestQuarterDetailsTable
                fullScreen={fullScreen}
                setFullScreen={handleFullScreenGird2}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};
export default CalculatedInterestDetailsTable;
